export default __webpack_public_path__ + "static/scene-two-bd1d6fe83ff61c53cdbb71969f1170b4.svg";